import { Component, OnInit, Inject, Input, ViewChild, Output, EventEmitter, ElementRef, PLATFORM_ID } from '@angular/core';
import { DOCUMENT } from '@angular/common'
import { HttpClient } from '@angular/common/http';
import { Observable, startWith, Subject, Subscription, takeUntil } from 'rxjs';
import Swal from 'sweetalert2';
import { environment } from 'src/environments/environment';
import { MangeClientsComponent } from './../../pages/mange-clients/mange-clients.component'
import { OverviewComponent } from 'src/app/components/overview/overview.component';
import { SharedService } from './../../services/sharedService/shared.service'
import { SharedService as SharedService1 } from '../../services/sharedService/shared-service.service';
import { AbstractControl, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { postServiceWorkerMessage } from 'src/serviceworker/message';
import { WorkerMessageType } from 'src/serviceworker/service/events/message';
import { LoggerService } from 'src/app/services/logger.service';
import { Store } from '@ngrx/store';
import { loadLanguageData, loadLanguageDataSuccess } from 'src/app/state/actions';
import { selectLanguageData } from 'src/app/state/selectors';
declare var $: any;
@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {
  private subscription: Subscription = new Subscription()
  @ViewChild('myInput') myInput: ElementRef;
  clientName: any;
  companyName
  ClientId: any;
  searchbox = true;
  clientDetails = false
  walletConfig: any
  tierConfig: any
  corpname: any;
  corpName: any;
  searchResults: any;
  currentUser: any;
  showeditcorp = false;
  showAddButton = false;
  appStatus: any;
  dropDownDisplay: boolean = false;
  dashBordLogo = environment.clientLogoDashBord;
  profiles: any[] = []
  accessToken: any
  // planspage= false

  @ViewChild(OverviewComponent)
  overview!: OverviewComponent;

  @ViewChild(MangeClientsComponent)
  manageclients!: MangeClientsComponent;
  @Output("GetCorpDetails") GetCorpDetails: EventEmitter<any> = new EventEmitter();
  @Output("ShowCorpDetails") ShowCorpDetails: EventEmitter<any> = new EventEmitter();
  @Output("editCorpDetails") editCorpDetails: EventEmitter<any> = new EventEmitter();

  changepasswordform: FormGroup = new FormGroup({
    oldpassword: new FormControl(''),
    newpassword: new FormControl(''),
    confirmpassword: new FormControl(''),

  });
  adminname: string;
  showMemberDetails: boolean = false;
  memberUserName: string;
  userName: any;
  link: string;
  showChevronSettings: boolean = true;
  role: string;
  showlang: any;
  languageData$: Observable<any>;
  private destroy$ = new Subject<void>();

  public lang: any = {};
  selectedLanguage: string;
  languageData: any;
  failedsignature: any;
  waddelCustomer: any;
  failedROE: any;
  filetype: any;
  signInResults: any;
  userInfo: any;
  portalInfo: any;

  constructor(
    private logger: LoggerService, 
    @Inject(DOCUMENT) private document: Document, 
    private formBuilder: FormBuilder, 
    private http: HttpClient, 
    public Shared: SharedService, 
    public _router: Router, 
    @Inject(PLATFORM_ID) private platformId: Object,
    private Shared1: SharedService1,
    private store: Store<{ languageData: [] }>
  ) {
    this.languageData$ = store.select(selectLanguageData);
   }

  ngOnInit(): void {
    // alert(this._router.url)
    // this.GetDetails()
    this.getLanguageTokens()

this.showlang =sessionStorage.getItem("language")


    this.getCorpName()
    this.getMemberUserName()

    this.changepasswordform = this.formBuilder.group(
      {
        oldpassword: [
          '',
          [
            Validators.required,
            Validators.minLength(8),
            Validators.maxLength(40),
          ],
        ],
        newpassword: [
          '',
          [
            Validators.required,
            Validators.minLength(8),
            Validators.maxLength(40),
          ],
        ],
        confirmpassword: [
          '',
          [
            Validators.required,
            Validators.minLength(8),
            Validators.maxLength(40),
          ],
        ],

      },
      {
        validator: this.ConfirmedValidator('newpassword', 'confirmpassword'),
      }

    );


    this.adminname = sessionStorage.getItem('adminName')
    this.role = sessionStorage.getItem('role')
    this.accessToken = sessionStorage.getItem('accessToken')
    let activeprofiles = JSON.parse(sessionStorage.getItem('profiles'))


    // this.Shared1.profiles.subscribe((profiles) => {
    //   console.log({ profiles })
    //   activeprofiles = profiles;
    // });

    if (activeprofiles && activeprofiles.length > 0) {
      for (let pf of activeprofiles) {
        console.log(pf.token == this.accessToken, pf.token, this.accessToken)
        if (pf.token != this.accessToken) {
          this.profiles.push(pf)
        }
      }
    } 
    console.log(this.profiles.length, activeprofiles)
    console.log(this.adminname)

    var signinResults = JSON.parse(sessionStorage.getItem('signinResults'));
    this.userInfo = signinResults?.userInfo;
    this.portalInfo = signinResults?.portalInfo;
    // this.showProfiles()
  }
  public getLanguageTokens(){
    // let body= {
    //   "project":"Admin Portal",
    //   "url":"Header"
    // }
    // this.http
    // .post('https://languageengineapi.aitestpro.com/string/project-url-strings',body, {
    //   headers: {
    //     'Content-Type': 'application/json',
    //   },
    // })
    // .subscribe(
    //   (response: any) => {
    //     console.log(response)
    //     this.lang = {};
    //     // this.languageData = response.strings
    //     this.selectedLanguage = sessionStorage.getItem("language")
    //     for (let token of response.strings) {
    //       this.lang[token.key] = token[this.selectedLanguage];
    //     }
    //     console.log(this.lang)
    //   })

    // this.store.dispatch(loadLanguageData());
    
    this.languageData$ = this.store.select(state => state.languageData).pipe(
      startWith([]),
      takeUntil(this.destroy$)
    );

    this.languageData$.subscribe(data => {
      if(data){
        // console.log(data)
        if (data?.languageData == undefined || Object.keys(data.languageData).length <= 0) {
          console.log('No data to process', new Date().toISOString());
          return;
        }
        // if(Object.keys(this.lang).length>0){
        //   return;
        // }
        setTimeout(()=>{
          this.lang = {};
          this.languageData = data?.languageData
          this.selectedLanguage = sessionStorage.getItem("language")
          for (let token of data?.languageData) {
            this.lang[token.key] = token[this.selectedLanguage];
          }
          // console.log('this.lang',this.lang)
        },0)
      }
    })
  }
  languageSelect(event:any){
    // console.log(event)
    sessionStorage.setItem("language",event.target.value)
    // window.location.reload()
    this.store.dispatch(loadLanguageDataSuccess({languageData : []}))
    this.store.dispatch(loadLanguageDataSuccess({languageData : this.languageData}))
    // this.store.dispatch(loadLanguageData())
  }
  
  toggleChevron(event: MouseEvent): void {
    console.log(this.showChevronSettings)
    if(this.showChevronSettings){
      this.getProfiles();
    }
    // let sessionDataForProfiles = JSON.parse(sessionStorage.getItem("adminProfiles"));
    // this.profiles = sessionDataForProfiles;
    event.stopPropagation();
    this.showChevronSettings = !this.showChevronSettings;
  }

  getMemberUserName() {
    this.Shared.memberUserName.subscribe(memberName => {
      this.memberUserName = memberName;
    });
    this.logger.log("memberUsername", this.memberUserName)
  }

  getCustomerData(customer?:any) {
    // this.customerid = sessionStorage.getItem('customerId');
    // this.accessToken = sessionStorage.getItem('accessToken');
    // this.clientName = sessionStorage.getItem('customerName');
    // let customerDataEndpoint = '/customer/'+this.customerid+'/details';
    // this.http.get(api.url+customerDataEndpoint, {
    //   headers:{
    //     Authorization: 'Bearer ' + this.accessToken,
    //     'Content-Type': 'application/json',
    // }}).subscribe((response:any)=>{
    //   if(response.status==200) {
        const response = { data: customer }
        this.failedsignature = response.data.failedDocs
        this.waddelCustomer = response.data.serviceType.waddelCustomer

        this.failedROE = response.data.ROE
        this.filetype = this.failedROE

        // if(this.failedsignature.length>0 && this.failedsignature.includes('ROE')){
        //           $("#Updatesignature").show()
        // }
        //  else{
        //   if(response.data.paymentMethodId==0){
        // this.overviewComponent.changeToCC()
        //   }
        // }

    //   }
    //   else {
    //     Swal.fire({allowOutsideClick: false,title: this.lang?.Info, text:response.message})
    //   }
    // },(error) => {
    //   Swal.fire({allowOutsideClick: false,title: this.lang?.Info, text: error.error.error.message})
    // });
  }

  getCorpName() {
    if (this._router.url.includes("edit-corporate")) {
      // this.appStatus = "Completed"
      this.ClientId = sessionStorage.getItem("corporateClientId") || "";
      this.Shared1.corporateName.subscribe((corporateName) => {
        this.clientName = corporateName;
      });

      this.Shared1.corporateStatus.subscribe((corporateStatus) => {
        this.appStatus = corporateStatus;
      });
    }
  }

  get changepass(): { [key: string]: AbstractControl } {
    return this.changepasswordform.controls;
  }
  ConfirmedValidator(controlName: string, matchingControlName: string) {
    return (formGroup: FormGroup) => {
      const control = formGroup.controls[controlName];
      const matchingControl = formGroup.controls[matchingControlName];
      if (
        matchingControl.errors &&
        !matchingControl.errors['confirmedValidator']
      ) {
        return;
      }
      if (control.value !== matchingControl.value) {
        matchingControl.setErrors({ confirmedValidator: true });
      } else {
        matchingControl.setErrors(null);
      }
    };
  }

  public headerDetails(mgs: any) {


    let formData = JSON.parse(sessionStorage.getItem("formData") || "")
    this.logger.log(formData)
    // this.clientName = sessionStorage.getItem("corporationName") || ""
    this.ClientId = sessionStorage.getItem("corporateClientId") || ""

    this.logger.log(mgs)

    if (mgs == "Home") {
      // if(formData.tierConfig=="false"){
      //   this.tierConfig ="NO"

      // }
      // else{
      //   this.tierConfig ="YES"
      // }
      // if(formData.walletConfig=="false"){
      //   this.walletConfig ="NO"
      // }
      // else{
      //   this.walletConfig ="YES"
      // }
      this.searchbox = true
      this.clientDetails = false;
      this.showMemberDetails = false;

    } else if (mgs == "member") {
      this.showMemberDetails = true;
      this.searchbox = false;
    }

    else {
      this.searchbox = false
      this.clientDetails = true;
      this.showMemberDetails = false;

      // alert(this.searchbox)

      // if(formData.tierConfig=="false"){
      //   this.tierConfig ="NO"

      // }
      // else{
      //   this.tierConfig ="YES"
      // }
      // if(formData.walletConfig=="false"){
      //   this.walletConfig ="NO"
      // }
      // else{
      //   this.walletConfig ="YES"
      // }

    }



  }


  public applicationStatus(status: number) {

    this.logger.log(status)

    if (status < 5) {

      this.appStatus = this.lang.Pending
    }
    else if (status <= 7) {
      this.appStatus = this.lang.Partially_Completed

    }
    else if (status <= 9) {
      this.appStatus = this.lang.Partially_Completed

    }
    else {
      this.appStatus = this.lang.Completed
    }

  }


  fetchSeries(id: string) {

    this.logger.log(this.corpname)

    let value = this.currentUser
    if (value.length == 0) {
      this.showeditcorp = false
      this.showAddButton = false
      this.dropDownDisplay = false
      this.GetCorpDetails.emit()
    }
    else {
      if (value.length > 2) {
        this.showAddButton = true
      }

    }

    if (value.length > 0) {
      var endPoint = '/api/ap/admin/corporate/search';
      var accessToken = sessionStorage.getItem('accessToken');
      // this.Shared.setCorpData(this.corpname);

      let inputData = {
        "searchArray": [{ "searchterm": "name", "searchvalue": value }],
        "count": 0,
        "strictOrpartial": true
      }

      this.http
        .post(environment.apiUrl + endPoint, inputData, {
          headers: {
            Authorization: 'Bearer ' + accessToken,
            'Content-Type': 'application/json',
          },
        })
        .subscribe(
          (response: any) => {
            if (response['status'] == 200) {
              this.searchResults = response.data;
              this.dropDownDisplay = true;
              this[id].nativeElement.focus();


              this.logger.log(this.searchResults)
              // this.showeditcorp =false
              let dispaly = response.data.filter(data => data.name == value);
              if (dispaly.length == 1) {//loop by ganesh
                this.GetCorpDetails.emit(dispaly[0].id)
              }


            } else {
              // Swal.fire('Invalid bank details');
            }
          },
          (error) => {

            Swal.fire({ title: this.lang.Error??'Error', text: error.error.message })
          }
        );
    }
  }

  getCorpDetails(item) {
    this.logger.log(item)
    var endPoint = '/api/ap/admin/corporate/search';
    var accessToken = sessionStorage.getItem('accessToken');

    if (item.length > 0) {
      let inputData = {
        "searchArray": [{ "searchterm": "name", "searchvalue": item }],
        "count": 0,
        "strictOrpartial": true
      }

      this.http
        .post(environment.apiUrl + endPoint, inputData, {
          headers: {
            Authorization: 'Bearer ' + accessToken,
            'Content-Type': 'application/json',
          },
        })
        .subscribe(
          (response: any) => {
            if (response['status'] == 200) {
              if (response.data) {
                this.showeditcorp = true
                this.GetCorpDetails.emit(response.data[0].id)
              }
            } else {
              // Swal.fire('Invalid bank details');
            }
          },
          (error) => {
            this.logger.log(error)
            Swal.fire({ title: this.lang.Error??'Error', text: error.error.error.message })
          }
        );

    }

  }


  getProfiles() {
    var endPoint = 'get-profiles-for-customer';
    var accessToken = sessionStorage.getItem('accessToken');
    console.log(JSON.parse(sessionStorage.getItem('signinResults'))?.email)
    var signinResults = JSON.parse(sessionStorage.getItem('signinResults'));
    var inputData = {
      username: signinResults?.email ?? sessionStorage.getItem('loginname') ?? ""
    }

    this.http
        .post(environment.commonLoginApiUrl + endPoint, inputData, {
          headers: {
            Authorization: 'Bearer ' + accessToken,
            'Content-Type': 'application/json',
          },
        })
        .subscribe(
          (response: any) => {
            if (response['status'] == 200) {
              if (response.data) {
                let roleFromSession = sessionStorage.getItem("role");
                // let data_:any = (response?.data?.profiles ?? [])?.filter((item:any) => item.name != signinResults.userName);
                let data_:any;
                if(roleFromSession){
                  data_ = (response?.data?.profiles ?? []).filter((item: any) => {
                  if (item.name === signinResults.userName &&
                      (item.type == roleFromSession)) {
                    return false;
                  }
 
                  if(signinResults.role == "BROKER"){
                    if (item.type === 'ADMINISTRATOR') {
                        return false;
                      }
                    }
 
                  return true;
                });
                }
               
                this.profiles = data_ ?? []
                let sessionDataForProfiles = JSON.stringify(this.profiles)
                sessionStorage.setItem("adminProfiles", sessionDataForProfiles)
                console.log({ "profile": this.profiles })
              }
 
            } else {
              // Swal.fire('Invalid bank details');
            }
          },
          (error) => {
            this.logger.log(error)
            Swal.fire({ title: this.lang.Error??'Error', text: error.error.error.message })
          }
        );

  }
  addCorpDetails() {

  }

  EditCorpDetails() {
    this.editCorpDetails.emit()
  }

  ShowCorpDetailsDetails() {
    this.logger.log(this.currentUser)
    this.ShowCorpDetails.emit(this.currentUser)
    this.showeditcorp = false
  }


  showDetails(series: any) {

    this.logger.log(series)

  }

  sidebarToggle() {
    //toggle sidebar function
    this.document.body.classList.toggle('toggle-sidebar');
  }

  async logout() {
    // window.open(environment.commonLoginUrl)
    sessionStorage.clear()
    this._router.navigate(['/login'])
    
    // let accessToken =  sessionStorage.getItem('accessToken')
    // this.http.post('http://[::1]:3002/api/ap/delete-session',{
    //   sessionId:accessToken,
    //   action:'logout'
    // }).subscribe((response:any)=>{
    //   console.log(response)
    //   if(response.status === 200 || response.status === "200"){
    //     this._router.navigate(['/login'])
    //     sessionStorage.clear()
    //   }else{
    //     Swal.fire({title:'Error',text:response.message})
    //     sessionStorage.clear()
    //   }
    // })
  }
  redirectToProfile(profile: any) {
    // sessionStorage.clear()

    console.log(profile)
    if(profile.type == "CORPORATE"){
      if(profile.link.includes("null")){
        return;
      }
    }
    window.open(`${profile.link}/loginWithToken/?token=${profile.token}&url=${profile.link}&adminName=${profile.name}`, '_blank')
  }


  matchedImages(role){
  let path:any = '../../../assets/img/'
  switch(role){
    case 'ADMINISTRATOR':
    case 'Administrator':
    case 'administrator':
    case 'admin':
    case 'Admin':
    default:
      path += 'GroupBenefitz admin.png'
      break;
    case 'MEMBER':
    case 'member':
    case 'Member':
    case 'GIG':
    case 'gig':
    case 'Gig':
      path += 'GB Member portal.png'
      break;
    case 'CORPORATE':
    case 'corporate':
    case 'Corporate':
      path += 'GB corp portal.png'
      break;
  }

  return path;
}

  changepassword() {
    $("#changepassword").show()
    this.changepasswordform.reset()
    this.changepasswordform.get('oldpassword')?.reset();
  }

  showProfiles() {
    this.getProfiles()
  }

  GetDetails() {
    setTimeout(() => {
      this.logger.log('header component')
      this.companyName = sessionStorage.getItem("groupContactName") || ""
      this.clientName = sessionStorage.getItem("corporateClientName") || ""
      this.ClientId = sessionStorage.getItem("corporateClientId") || ""
    }, 3000);
  }

  closeChangepassmodel() {
    $("#changepassword").hide()
    this.changepasswordform.reset()
    this.changepasswordform.get('oldpassword')?.reset();
  }

  closeSwitchProfileModal() {
    $("#switchProfileModal").hide()
  }

  SubmitChangePassword() {
    // var endPoint = "/api/ap/user/changePassword ";
    if (this.changepasswordform.value.oldpassword != this.changepasswordform.value.newpassword) {
      let obj = {
        "oldpassword": this.changepasswordform.value.oldpassword,
        "newpassword": this.changepasswordform.value.newpassword
      }
      var endPoint = "/api/ap/user/changePassword";
      var accessToken = sessionStorage.getItem('accessToken');

      this.http
        .post(environment.apiUrl + endPoint, obj, {
          headers: {
            Authorization: 'Bearer ' + accessToken,
            'Content-Type': 'application/json',
          },
        }).subscribe((response: any) => {

          if (response["statusCode"] == 200 || response["status"] == 200) {
            Swal.fire({ title: 'Success', text: response.message })
            this.changepasswordform.reset()
            $("#changepassword").hide()
          }
          else if (response["statusCode"] == 400 || response["status"] == 400) {
            Swal.fire({ title: this.lang.Error??'Error', text: response.message })
          }
          else {

            Swal.fire({ title: this.lang.Error??'Error', text: response.message })
          }
        }, (error) => {
          Swal.fire({ title: this.lang.Error??'Error', text: error.error.error.message })
        });

    } else {
      Swal.fire({ title: this.lang.Error??'Error', text: this.lang.Old_password_same_as_New_password })
    }
  }

  diaplayinInputbox(details: any) {
    this.currentUser = details.name;
    this.GetCorpDetails.emit(details.id);
    this.dropDownDisplay = false;

  }
  hideList() {
    this.dropDownDisplay = false;
  }

}
